import React, { useState, useEffect } from 'react';
import '../styles/SentenceDisplay.css';

export function SentenceDisplay({ sentence, visible, onComplete }) {
  const [visibleParts, setVisibleParts] = useState([]);
  const [visibleWords, setVisibleWords] = useState(sentence.map(() => 0));

  useEffect(() => {
    setVisibleParts([]);
    setVisibleWords(sentence.map(() => 0));
    if (visible && sentence.length > 0) {
      let timeout;
      const showNextPart = (index) => {
        if (index < sentence.length) {
          setVisibleParts((prev) => [...prev, index]);
          timeout = setTimeout(() => showNextPart(index + 1), 200); // 500ms delay between parts
        }
      };
      showNextPart(0);
      return () => clearTimeout(timeout);
    }
  }, [sentence, visible]);

  useEffect(() => {
    if (visible && sentence.length > 0) {
      const intervals = sentence.map((part, partIndex) => {
        const words = part.match(/\S+|\s+/g) || [];
        return setInterval(() => {
          if (visibleParts.includes(partIndex)) {
            setVisibleWords((prev) => {
              const newVisibleWords = [...prev];
              if (newVisibleWords[partIndex] < words.length) {
                newVisibleWords[partIndex]++;
                if (
                  partIndex === sentence.length - 1 &&
                  newVisibleWords[partIndex] === words.length
                ) {
                  clearInterval(intervals[partIndex]);
                  onComplete();
                }
              }
              return newVisibleWords;
            });
          }
        }, 100);
      });

      return () => intervals.forEach(clearInterval);
    }
  }, [sentence, visible, onComplete, visibleParts]);

  if (!visible || sentence.length === 0) return null;

  const columnCount = sentence.length;
 
  return (
    <div className={`sentence-display-container columns-${columnCount}`}>
      {sentence.map((part, partIndex) => (
        <div
          key={partIndex}
          className={`sentence-display ${
            visibleParts.includes(partIndex) ? 'visible' : ''
          }`}
        >
          {(part.match(/\S+|\s+/g) || []).map((word, wordIndex) => (
            <span
              key={wordIndex}
              className={`word ${
                wordIndex < visibleWords[partIndex] ? 'visible' : ''
              } ${word.trim() === '' ? 'space' : ''}`}
        >
              {word}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}
